import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  news: {
    data: [],
    meta: {
      total: 0,
    },
  },
  mainNews: [],
};

// TODO: fetch all the news
export const fetchNews = createAsyncThunk(
  "fetchNews/news",
  async ({ enqueueSnackbar, limit = 10, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`news`, {
        params: {
          limit,
          page: page + 1,
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.meta.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create news
export const createNews = createAsyncThunk(
  "createNews/news",
  async (
    { data, enqueueSnackbar, handleClose, activeTab, setActiveTab },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.post(`news`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        activeTab,
        setActiveTab,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update news
export const updateNews = createAsyncThunk(
  "updateNews/news",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`news/${id}`, data);
      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete news
export const deleteNews = createAsyncThunk(
  "deleteNews/news",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`news/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const newslice = createSlice({
  name: "news",
  initialState,
  reducers: {
    resetLoadings: (state) => {
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
  extraReducers: (builder) => {
    // TODO: get news
    builder.addCase(fetchNews.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchNews.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.news.data = action.payload.data;
      state.news.meta.total = action.payload.meta.total;
    });

    builder.addCase(fetchNews.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: create news
    builder.addCase(createNews.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createNews.fulfilled, (state, action) => {
      state.isLoading = false;
      state.news.data = [action.payload.data, ...state.news.data];
      state.news.meta.total = state.news.meta.total + 1;
      action.payload.enqueueSnackbar("News is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createNews.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: update news
    builder.addCase(updateNews.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateNews.fulfilled, (state, action) => {
      state.isLoading = false;
      state.news.data = state?.news?.data?.map((news) => {
        if (news.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return news;
        }
      });
      action.payload.enqueueSnackbar("News is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateNews.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete news
    builder.addCase(deleteNews.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteNews.fulfilled, (state, action) => {
      state.isLoading = false;
      state.news.data = state.news.data.filter(
        (news) => news.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("News is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteNews.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default newslice.reducer;

export const { resetLoadings } = newslice.actions;
